import SummariesPersonalRegisteredWithVat from "@/views/summaries/personal_registered_with_vat/index.vue";
import SummariesPersonalRegisteredWithoutVat from "@/views/summaries/personal_registered_without_vat/index.vue";
import SummariesPersonalNotRegister from "@/views/summaries/personal_not_register/index.vue";
import SummariesPersonalNormalNeedRegister from "@/views/summaries/personal_normal_need_register/index.vue";
import SummariesPersonalNormalNotRegister from "@/views/summaries/personal_normal_not_register/index.vue";

import SummariesCorpRegisteredWithVat from "@/views/summaries/corp_registered_with_vat/index.vue";
import SummariesCorpRegisterdWithoutVat from "@/views/summaries/corp_registered_without_vat/index.vue";
import SummariesCorpNotRegister from "@/views/summaries/corp_not_register/index.vue";
import SummariesCorpNormalNeedRegister from "@/views/summaries/corp_normal_need_register/index.vue";
import SummariesCorpNormalNotRegister from "@/views/summaries/corp_normal_not_register/index.vue";

import SummariesCorpDecision from "@/views/summaries/corp_decision/index.vue";
import SummariesPersonalDecision from "@/views/summaries/personal_decision/index.vue";

export default [
  {
    path: "/summaries/personal_registered_with_vat",
    name: "SummariesPersonalRegisteredWithVat",
    component: SummariesPersonalRegisteredWithVat,
  },
  {
    path: "/summaries/personal_registered_without_vat",
    name: "SummariesPersonalRegisteredWithoutVat",
    component: SummariesPersonalRegisteredWithoutVat,
  },
  {
    path: "/summaries/personal_normal_need_register",
    name: "SummariesPersonalNormalNeedRegister",
    component: SummariesPersonalNormalNeedRegister,
  },
  {
    path: "/summaries/personal_not_register",
    name: "SummariesPersonalNotRegister",
    component: SummariesPersonalNotRegister,
  },
  {
    path: "/summaries/personal_normal_not_register",
    name: "SummariesPersonalNormalNotRegister",
    component: SummariesPersonalNormalNotRegister,
  },
  {
    path: "/summaries/corp_not_register",
    name: "SummariesCorpNotRegister",
    component: SummariesCorpNotRegister,
  },
  {
    path: "/summaries/corp_normal_need_register",
    name: "SummariesCorpNormalNeedRegister",
    component: SummariesCorpNormalNeedRegister,
  },
  {
    path: "/summaries/corp_normal_not_register",
    name: "SummariesCorpNormalNotRegister",
    component: SummariesCorpNormalNotRegister,
  },
  {
    path: "/summaries/corp_registered_with_vat",
    name: "SummariesCorpRegisteredWithVat",
    component: SummariesCorpRegisteredWithVat,
  },
  {
    path: "/summaries/corp_registered_without_vat",
    name: "SummariesCorpRegisterdWithoutVat",
    component: SummariesCorpRegisterdWithoutVat,
  },
  {
    path: "/summaries/personal_decision",
    name: "SummariesPersonalDecision",
    component: SummariesPersonalDecision,
  },
  {
    path: "/summaries/corp_decision",
    name: "SummariesCorpDecision",
    component: SummariesCorpDecision,
  },
];
